import { render, staticRenderFns } from "./form_historic_monetization_component.vue?vue&type=template&id=b6be724e&scoped=true"
import script from "./form_historic_monetization_component.vue?vue&type=script&lang=js"
export * from "./form_historic_monetization_component.vue?vue&type=script&lang=js"
import style0 from "./form_historic_monetization_component.vue?vue&type=style&index=0&id=b6be724e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6be724e",
  null
  
)

export default component.exports